export const CHARGE_KEYS = ['total', 'perTraveller', 'perAdult'] as const;

export type Charge = {
  amount: string | number;
  currency: string;
};
export type ChargeKey = (typeof CHARGE_KEYS)[number];
export type Charges = Record<ChargeKey, Charge>;
